import React from "react";
import Copyright from "./copyright";

class Footer extends React.Component{
    render () {
        return (
            <div>
                <Copyright />
            </div>
        )
    }
}

export default Footer;